import {AfterViewInit, Component} from "@angular/core";
import {AppEditorComponent} from "../../editor/app.editor.component";
import {
    ComponentSettings,
    PREDEFINED_OPTIONS,
    PREDEFINED_VALIDATORS
} from "../model/dictionary";
import {COMPONENT_TYPES_REGISTRY} from "../model/registry";
import {FormComponent} from "../model/form-component";
import {AppRendererComponent} from "../app.renderer.component";
import {FormGroup} from "@angular/forms";

@Component({
    selector: "samples",
    templateUrl: './samples.component.html',
    styleUrls: ['./samples.component.css'],
})
export class SamplesComponent implements AfterViewInit {

    showFiller = true;
    componentTypes:ComponentSettings[] = Array.from( COMPONENT_TYPES_REGISTRY.values() );
    allComponentTypes:ComponentSettings[] = Array.from( COMPONENT_TYPES_REGISTRY.values() );
    selectedComponent:ComponentSettings;
    showDATA = true;
    showUI = true;
    showOnlyWithChildren = false;
    validators = PREDEFINED_VALIDATORS;
    options = PREDEFINED_OPTIONS;

    formGroup = new FormGroup({});
    //samples : Map<string,FormComponent> = new Map();
    selectedSample:FormComponent;

    ngAfterViewInit(): void {
        //super.ngOnInit()
        //Array.from( COMPONENT_TYPES_REGISTRY.values() )
        this.allComponentTypes
            .forEach(settings => {
                //this.samples.set(settings.name, this.getSampleComponent(settings));
                settings.sample = this.getSampleComponent(settings);
            });
    }

    filter() {
        console.log('filter');

        this.componentTypes = Array.from( COMPONENT_TYPES_REGISTRY.values() )
            .filter(settings => (
                ((this.showDATA) || (!this.showDATA && !settings.allowsData)) &&
                ((this.showUI) || (!this.showUI && settings.allowsData)) &&
                ((this.showOnlyWithChildren && settings.allowsChildren) || !this.showOnlyWithChildren)
            ));
    }

    getSampleComponent(selectedComponent: ComponentSettings): FormComponent {
        console.log('selectedComponent.type:' + selectedComponent.type);
        console.log('name:' + selectedComponent.name.toLowerCase());
        var sample : FormComponent;
        sample = new FormComponent();
        sample.type = selectedComponent.name.toLowerCase();
        sample.id = sample.type;
        sample.label = 'Sample label ('+sample.type+'):';
        return sample;
    }

    changeSelection(selectedComponent: ComponentSettings) {
        console.log('changeSelection');
        this.selectedComponent = selectedComponent;
        this.selectedSample = this.selectedComponent.sample;//this.samples.get(this.selectedComponent.name);
    }

}
